/**
 * Utilitários para manipulação de strings
 */

/**
 * Remove acentos de uma string
 * @param str - String a ser processada
 * @returns String sem acentos
 */
export function removeAccents(str: string): string {
  return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}

/**
 * Normaliza uma string para busca (remove acentos e converte para minúsculas)
 * @param str - String a ser normalizada
 * @returns String normalizada
 */
export function normalizeForSearch(str: string): string {
  return removeAccents(str.toLowerCase().trim());
}

